export default {
  PLACEHOLDER_SELECT_ADDRESS: 'Bitte wählen Sie eine Adresse aus',
  INVOICES_MY_INVOICES: 'Meine Rechnungen',
  INVOICES_INVOICES_PURCHASE_HISTORY: 'Rechnungen / Kaufhistorie',
  INVOICES_NO_INVOICES_FOUND: 'Es wurden keine Rechnungen gefunden.',
  INVOICES_ORDER_NUMBER: 'Bestellnummer',
  INVOICES_INVOICE_DATE: 'Rechnungsdatum',
  INVOICES_PAYMENT_METHOD: 'Zahlungsart',
  INVOICES_PRICES: 'Preis',
  INVOICES_DOWNLOAD: 'Download',
  INVOICES_PER_PAGE: '/ Seite',
  PAYMENT_METHOD_CREDIT_CARD: 'Kreditkarte',
  PAYMENT_METHOD_ADVANCED_PAYMENT: 'Vorkasse',
  CHECKOUT_DELIVER_TO: 'Lieferung an:',
  CHECKOUT_BILLING_TO: 'Rechnung an:',
  CHECKOUT_SAMPLE_COPIES_ADDRESS: 'Lieferadresse Belegexemplare',
  CARD_ITEM_BUTTON_SAMPLE_COPIES: 'Belegexemplare',
  CUSTOMER_SERVICE_TITLE: 'Kundenservice',
  CUSTOMER_SERVICE_CONTACT: 'Kontakt',
  CUSTOMER_SERVICE_AVAILABLE_FROM: 'Verfügbar ab',
  CUSTOMER_SERVICE_AVAILABLE_UNTIL: 'Verfügbar bis',
  CHANGE_PW_TITLE: 'Ihr Passwort muss geändert werden.',
  CHANGE_PW_CHANGE: 'Passwort ändern',
  CHANGE_PW_CURRENT_PW: 'Aktuelles Passwort*',
  CHANGE_PW_NEW_PW: 'Neues Passwort*',
  CHANGE_PW_REPEAT_PW: 'Neues Passwort wiederholen*',
  CHANGE_PW_EMAIL_MISMATCH: 'Die E-Mail-Adresse stimmt nicht mit der des aktuell angemeldeten Benutzers überein.',

  ASSERT_FIELD_REQUIRED: 'Dieses Feld ist erforderlich',
  ASSERT_MINIMUM_LENGTH: 'Minimale Zeichenanzahl:',
  ASSERT_MAXIMUM_LENGTH: 'Maximale Zeichenanzahl:',
  ASSERT_BOTH_FIELDS_MUST_BE_EQUAL: 'Die Eingaben müssen übereinstimmen.',
  ASSERT_INVALID_EMAIL: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  ASSERT_INVALID_PASSWORD:
    'Dein Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',

  AWS_COGNITO_ERROR_ATTEMPT_LIMIT: 'Zu viele Versuche. Bitte versuche es später erneut.',
  AWS_COGNITO_ERROR_USER_NOT_CONFIRMED:
    'Dein Konto wurde noch nicht bestätigt. Bitte klicke auf den Link in der Bestätigungs-E-Mail, die wir dir gesendet haben.',
  AWS_COGNITO_ERROR_PASSWORD_RESET_REQUIRED: 'Du musst dein Passwort zurücksetzen, bevor du dich anmelden kannst.',
  AWS_COGNITO_ERROR_NETWORK:
    'Die Verbindung zum Anmeldedienst konnte nicht hergestellt werden. Bitte versuche es später noch einmal.',
  AWS_COGNITO_ERROR_TOO_MANY_REQUESTS:
    'Unser Service ist derzeit stark ausgelastet. Bitte versuche es später noch einmal.',
  AWS_COGNITO_ERROR_LIMIT_EXCEEDED: 'Zu viele Versuche. Bitte warte einige Minuten und versuche es erneut.',
  AWS_COGNITO_ERROR_SESSION_EXPIRED:
    'Deine Sitzung ist abgelaufen. Bitte melde dich erneut mit deinem vorläufigen Passwort an.',

  LOGIN_EMAIL: 'E-Mail-Adresse*',
  LOGIN_PASSWORD: 'Passwort*',
  LOGIN_LOGIN: 'Login',
  LOGIN_FORGOT_PASSWORD: 'Passwort zurücksetzen',

  FORGOT_PASSWORD_CODE_SENT:
    'Wenn die E-Mail-Adresse registriert ist, erhältst du in Kürze einen Code, um dein Passwort zurückzusetzen.',
  FORGOT_PASSWORD_INVALID_CODE: 'Invalid verification code provided, please try again.',
  FORGOT_PASSWORD_SEND_CODE: 'Bestätigungscode anfordern',
  FORGOT_PASSWORD_EMAIL: 'E-Mail-Adresse*',
  FORGOT_PASSWORD_RESET_CODE: 'Bestätigungscode*',
  FORGOT_PASSWORD_NEW_PASSWORD: 'Neues Passwort*',
  FORGOT_PASSWORD_REPEAT_NEW_PASSWORD: 'Neues Passwort wiederholen*',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Zurück zum Login',
  FORGOT_PASSWORD_RESET_PASSWORD: 'Passwort zurücksetzen',
  FORGOT_PASSWORD_CODE_RESENT:
    'Wenn die E-Mail-Adresse registriert ist, erhältst du in Kürze einen Code, um dein Passwort zurückzusetzen.',
  FORGOT_PASSWORD_HINTS_TITLE: 'Keine E-Mail erhalten?',
  FORGOT_PASSWORD_HINT_SPAM: 'Überprüfe deinen Spam-Ordner.',
  FORGOT_PASSWORD_HINT_EMAIL: 'Überprüfe, ob du die richtige E-Mail-Adresse eingegeben hast',
  FORGOT_PASSWORD_CHANGE_EMAIL: 'E-Mail-Adresse ändern',
  FORGOT_PASSWORD_HINT_RESEND: 'Code erneut senden',
  LOGIN_RESEND_CONFIRMATION: 'Bestätigungs-Mail erneut senden',
  LOGIN_RESEND_CONFIRMATION_SUCCESS: 'Wir haben dir eine neue Bestätigungs-Mail gesendet.',
  LOGIN_RESEND_CONFIRMATION_ERROR:
    'Die Bestätigungs-Mail konnte nicht gesendet werden. Bitte versuche es später erneut.',
  SHOW_PASSWORD: 'Passwort anzeigen',
  HIDE_PASSWORD: 'Passwort ausblenden',

  MODAL_OK: 'OK',
  MODAL_CANCEL: 'Abbrechen',
  MODAL_DUPLICATE_FILE_TITLE: 'Es wurden Duplikate gefunden',
  MODAL_DUPLICATE_FILE_DESCRIPTION: 'Die folgende Datei wurde bereits hochgeladen:',

  PLUS_MATERIAL_HINT: 'Geeignet für den Einsatz im Eiskübel.',
  LOADING_DATA_ISSUE_JOB: 'Bitte warten Sie, während wir Ihre Jobkonfigurationen abrufen...',
  SHOW_UNIT_COUNT: 'Anzahl der Einheiten anzeigen',
  LOT: 'LOT (Optional)',
  LINE_1: 'Zeile 1',
  LINE_2: 'Zeile 2',
  LINE_3: 'Zeile 3',
  LINE_4: 'Zeile 4',
  PROOFING_SERVICE: 'Probedruck',

  ORDER_TEMPLATES_TITLE: 'Bestellvorlagen',
  ORDER_TEMPLATES_SELECT: 'Ausgewählte Bestellvorlage',
  ORDER_TEMPLATES_SELECT_PLACEHOLDER: 'Bitte Bestellvorlage auswählen',
  ORDER_TEMPLATES_NO_TEMPLATES: 'Es sind keine Bestellvorlagen verfügbar.',

  PRODUCTION_TYPE_STANDARD: 'Standard',
  PRODUCTION_TYPE_EXPRESS: '48h Express',
  PRODUCTION_TYPE_SUPER_EXPRESS: '24h Super Express',
  PRODUCTION_TYPE_ESTIMATED_SHIPPING_DATE: 'Voraussichtliches Versanddatum',
  PRODUCTION_TYPE_SHIPPING_DATE: 'Versanddatum',
  PRODUCTION_TYPE_NOT_POSSIBLE: 'Nicht möglich',

  SHOW_PRICE_IN_CURRENCY: 'Preis in {currency} anzeigen',
  CURRENCY_SWITCH_DISABLED_CART_NOT_EMPTY:
    'Die Währung kann nicht geändert werden, solange sich Artikel in Ihrem Warenkorb befinden.',
  CART_MIXED_CURRENCY_WARNING:
    'Ihr Warenkorb enthält Artikel in unterschiedlichen Währungen. Bitte entfernen Sie die Artikel in einer anderen Währung, bevor Sie zur Kasse gehen.',
  CHECKOUT_USER_DISABLED:
    'Mit Ihrem Konto können keine Bestellungen aufgegeben werden. Bitte wenden Sie sich an unseren Kundenservice.',
  DESIGN_SERVICE_CURRENCY_DISABLED: 'Design Service kann nur in {currency} bestellt werden.',
  PACKAGE_ORDER_CURRENCY_DISABLED: 'Dieses Paket kann nur in {currency} bestellt werden.',
  CHANGE_CURRENCY_CALCULATOR: 'Bitte ändern Sie zuerst die Währung im Kalkulator auf der Startseite.',

  CART_ITEM_DISCOUNT_NOT_APPLICABLE: 'Für diesen Artikel wird aufgrund der Sonderpreise kein Kundenrabatt gewährt.',
  UPLOAD_SORTS_CONFIG_NOT_SAVED:
    'Ihre Sortenkonfiguration konnte nicht gespeichert werden. Bitte prüfen Sie, ob die Mengen aller Sorten der Gesamtmenge entsprechen, und versuchen Sie es erneut.',
  HPI_WHITE: 'HPI-weiẞ',
  YES: 'Ja',
  NO: 'Nein',

  UPS_STANDARD_SHIPPING: 'UPS Standard',
  UPS_EXPRESS_SHIPPING: 'UPS Express Saver',
  UPS_STANDARD_SHIPPING_NEUTRAL: 'UPS Standard – Versand mit CO₂-Kompensation',
  UPS_EXPRESS_SHIPPING_NEUTRAL: 'UPS Express Saver – Versand mit CO₂-Kompensation'
} as const
